<template>
  <div
    class="flex flex-col"
    :class="{ 'p-[5px]': smallSvg, '!pb-0': smallSvg && DockStatus }"
  >
    <div class="content_device_action">
      <div @click="drone_distance_limit_status_state()">
        <svg
          class="w-[55px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 705.62 309.45"
        >
          <g>
            <path
              d="M508.32,43.92c28.3-.01,51.71,22.04,53.38,50.29l.09,3.15h-18.01c.02-19.58-15.85-35.47-35.43-35.49-19.58-.02-35.47,15.85-35.49,35.43-.02,18.57,14.29,34,32.8,35.39l2.66.11v17.99c-29.53,0-53.46-23.94-53.46-53.46s23.94-53.46,53.46-53.46v.06ZM508.32,186.09v18c-19.69-.12-35.76,15.74-35.88,35.44-.12,19.69,15.74,35.76,35.44,35.88,18.83.12,34.51-14.43,35.8-33.21l.11-2.66h17.98c.02,29.53-23.9,53.49-53.43,53.51-29.53.02-53.49-23.9-53.51-53.43-.02-28.33,22.06-51.76,50.35-53.42l3.14-.09h.02ZM650.61,186.09c29.94-.43,54.57,23.49,55,53.44.43,29.94-23.49,54.57-53.44,55-29.33.42-53.68-22.56-54.96-51.86l-.08-3.15h18c-.02,19.58,15.84,35.48,35.42,35.5,19.58.02,35.48-15.84,35.5-35.42.02-18.57-14.29-34.01-32.81-35.4l-2.66-.11v-18ZM650.61,43.92c29.51.01,53.43,23.95,53.41,53.46-.01,28.27-22.05,51.64-50.27,53.32l-3.14.09v-18c19.69.12,35.76-15.74,35.88-35.44.12-19.69-15.74-35.76-35.44-35.88-18.84-.12-34.52,14.44-35.8,33.23l-.11,2.66h-18.01c0-29.52,23.93-53.45,53.45-53.45,0,0,0,0,0,0h.01ZM653.02,229.5c5.05,1.91,7.6,7.55,5.69,12.6-1.91,5.05-7.55,7.6-12.6,5.69-3.19-1.2-5.52-3.98-6.15-7.33-1.74-2.59-3.78-4.95-6.09-7.05-2-2.03-6.8-5.56-12.29-9.89-11.55-10.71-26.08-17.67-41.66-19.97-12.87,1.56-24.99,6.91-34.81,15.38-2.87,2-8.37,6.15-15.56,11.51-4.54,3.52-8.42,7.83-11.43,12.72l-.09-.09c-2.43,4.85-8.33,6.82-13.18,4.39s-6.82-8.33-4.39-13.18c1.27-2.54,3.57-4.4,6.31-5.11,4.22-1.34,7.92-3.96,10.57-7.51,5.27-6.01,10.23-12.28,14.86-18.8,8.1-9.22,13.34-20.61,15.07-32.76-1.23-11.77-6.1-22.86-13.94-31.73-2.49-3.7-7.84-10.57-13.23-17.21-4.21-5.79-9.54-10.68-15.69-14.36h0c-4.69-2.69-6.32-8.67-3.63-13.36s8.67-6.32,13.36-3.63c2.5,1.43,4.24,3.89,4.76,6.72,3.57,5.68,8.06,10.74,13.28,14.96,0,0,12.02,9.03,15.07,11.03,20.65,13.83,47.73,13.33,67.87-1.25,6.94-5.7,18.67-14.69,18.67-14.69,2.52-2.56,4.54-5.57,5.95-8.87.27-5.43,4.88-9.61,10.3-9.34s9.61,4.88,9.34,10.3c-.18,3.65-2.37,6.9-5.68,8.44h0c-4,2.19-7.41,5.31-9.95,9.09,0,0-6.22,8.72-13.75,18.34-9.52,10.11-15.43,23.08-16.83,36.89,2.05,13.48,8.37,25.94,18.04,35.57,4.32,6.32,9.27,12.18,14.78,17.49,2.02,2.03,4.35,3.72,6.91,5.02l.11-.02Z"
              style="fill: #fff; fill-rule: evenodd"
            />
          </g>
          <path
            d="M218.43,309.44v-12.13H33.37v12.14H12.15v-12.14h-.45c-6.46,0-11.7-5.24-11.7-11.7h0V71.5c0-19.38,15.71-35.09,35.09-35.09h140.86V0h21.25v36.4h19.52c19.38,0,35.09,15.71,35.09,35.09v214.12c0,6.46-5.24,11.7-11.7,11.7h-.45v12.14l-21.23-.02h0Z"
            style="fill: #fff"
          />
          <path
            d="M155.22,140.74l59.18,53.08c1.7,1.55,4.34,1.42,5.88-.29.1-.11.19-.22.27-.33l11.56-14.74c1.54-1.97,1.33-4.79-.48-6.52l-59.15-53.13c-1.72-1.53-4.35-1.37-5.88.35h0c-.09.1-.17.2-.25.31l-11.58,14.72c-1.57,1.97-1.37,4.81.45,6.55"
            style="fill: #3e3e3e"
          />
          <path
            d="M232.78,172.51c6.01,5.05,6.79,14.01,1.74,20.02-5.05,6.01-14.01,6.79-20.02,1.74-6.01-5.05-6.79-14.01-1.74-20.02,5.05-6.01,14.01-6.79,20.02-1.75h0"
            style="fill: #fff"
          />
          <path
            d="M232.78,172.52c6,5.04,6.78,14,1.74,20.01-5.04,6-14,6.78-20.01,1.74-6-5.04-6.78-14-1.74-20,5.04-6.01,14-6.79,20.01-1.75h0Z"
            style="fill: none; stroke: #545454; stroke-width: 5.85px"
          />
          <path
            d="M170.45,112.96c7.24,6.08,8.18,16.89,2.1,24.13-6.08,7.24-16.89,8.18-24.13,2.1-7.24-6.08-8.18-16.89-2.1-24.13h0c6.08-7.24,16.89-8.18,24.13-2.1"
            style="fill: #9f9f9f"
          />
          <path
            d="M168.56,115.2c6,5.04,6.78,14,1.74,20.01-5.04,6-14,6.78-20.01,1.74-6-5.04-6.78-14-1.74-20,5.04-6.01,14-6.79,20.01-1.75h0Z"
            style="fill: none; stroke: #545454; stroke-width: 5.85px"
          />
          <path
            d="M150.3,136.96c-6.01-5.04-6.79-14.01-1.74-20.01,5.04-6.01,14.01-6.79,20.01-1.74,6.01,5.04,6.79,14,1.74,20.01-5.05,6-14,6.78-20.01,1.74"
            style="fill: #fff"
          />
          <path
            d="M166.69,117.44c-4.77-4.01-11.89-3.39-15.89,1.38-4.01,4.77-3.39,11.89,1.38,15.89s11.89,3.39,15.89-1.38h0c4-4.77,3.38-11.88-1.39-15.89M170.45,112.96c7.24,6.08,8.18,16.89,2.1,24.13s-16.89,8.18-24.13,2.1c-7.24-6.08-8.18-16.89-2.1-24.13h0c6.08-7.24,16.89-8.18,24.13-2.1"
            style="fill: #545454"
          />
          <path
            d="M96.54,140.72l-59.17,53.09c-1.7,1.54-4.33,1.41-5.87-.29-.1-.11-.19-.23-.28-.35l-11.58-14.72c-1.54-1.97-1.33-4.79.49-6.52l59.17-53.14c1.72-1.53,4.35-1.37,5.88.35h0c.09.1.17.2.24.3l11.58,14.72c1.57,1.97,1.37,4.82-.45,6.55"
            style="fill: #3e3e3e"
          />
          <path
            d="M37.26,194.26c-6.01,5.04-14.96,4.26-20.01-1.75-5.04-6.01-4.26-14.96,1.75-20.01,6.01-5.04,14.96-4.26,20,1.74s4.27,14.96-1.74,20.01h0"
            style="fill: #fff"
          />
          <path
            d="M37.26,194.26c-6.01,5.04-14.96,4.26-20.01-1.75-5.04-6.01-4.26-14.96,1.75-20.01,6.01-5.04,14.96-4.26,20,1.74s4.27,14.96-1.74,20.01h0Z"
            style="fill: none; stroke: #545454; stroke-width: 5.85px"
          />
          <path
            d="M101.46,136.94c-6.01,5.04-14.96,4.26-20.01-1.75s-4.26-14.96,1.75-20.01c6.01-5.04,14.96-4.26,20,1.74s4.27,14.96-1.74,20.01h0"
            style="fill: #fff"
          />
          <path
            d="M101.46,136.94c-6.01,5.04-14.96,4.26-20.01-1.75s-4.26-14.96,1.75-20.01c6.01-5.04,14.96-4.26,20,1.74s4.27,14.96-1.74,20.01h0Z"
            style="fill: none; stroke: #545454; stroke-width: 5.85px"
          />
          <rect
            x="284.7"
            y="156.9"
            width="64.83"
            height="27.07"
            style="fill: #fff"
          />
          <rect
            x="381.24"
            y="156.9"
            width="64.83"
            height="27.07"
            style="fill: #fff"
          />
        </svg>
        <div>
          <p>{{ $e("Distance maximal de vol") }}</p>
          <span class="toogle_info">
            <p v-if="DroneDistanceLimitStatusState">
              {{ $e("Activer la de distance de vol") }}
            </p>
            <p v-else>{{ $e("Désactiver la de distance de vol") }}</p>
          </span>
        </div>

        <div
          class="block w-[15px] h-[15px] ml-4 rounded-full"
          :class="DroneDistanceLimitStatusState ? 'bg-success' : 'bg-error'"
        ></div>
      </div>

      <div class="no_hover !justify-start" v-if="DroneDistanceLimitStatusState">
        <div>
          <p>
            {{ $e("Distance maximal de vol") }} :
            {{ config.drone.status.distance_limit_status.distance_limit }}m
          </p>

          <div class="flex pt-2 pb-1 text-[10px]" v-if="false">
            {{ $e("Modifier") }} :
            <input
              type="number"
              name=""
              id="DroneDistanceLimitStatusState"
              @change="verifDroneDistanceLimit()"
              class="ml-2 px-2 py-0 w-[100px] h-[17px] text-[11px]"
              v-model="valueDistanceEdit"
              :placeholder="
                config.drone.status.distance_limit_status.distance_limit
              "
            /> m

            <svg
              v-if="valueDistanceEdit !== false"
              @click="saveDistanceEdit()"
              class="w-[20px] ml-4 fill-current cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 110.0 110.0"
            >
              <g fill-rule="evenodd">
                <path
                  d="m66.52 15.805c4.8789-4.8828 12.797-4.8828 17.676 0 4.8828 4.8789 4.8828 12.797 0 17.676l-29.676 29.676c-1.7422 1.7461-3.9648 2.9336-6.3867 3.418l-12.258 2.4531c-1.3633 0.27344-2.7773-0.15625-3.7617-1.1406s-1.4141-2.3984-1.1406-3.7617l2.4531-12.258c0.48438-2.4219 1.6719-4.6445 3.418-6.3867zm11.785 5.8906c-1.6289-1.625-4.2656-1.625-5.8945 0l-1.5781 1.5781 5.8945 5.8945 1.5781-1.5781c1.625-1.6289 1.625-4.2656 0-5.8945zm-7.4727 13.363-5.8906-5.8906-22.207 22.203c-0.58203 0.58203-0.97656 1.3242-1.1367 2.1289l-1.2266 6.1289 6.1289-1.2266c0.80469-0.16016 1.5469-0.55469 2.1289-1.1367zm-45.832-14.227c-2.3008 0-4.168 1.8672-4.168 4.168v50c0 2.3008 1.8672 4.168 4.168 4.168h50c2.3008 0 4.168-1.8672 4.168-4.168v-25c0-2.3008 1.8633-4.168 4.1641-4.168s4.168 1.8672 4.168 4.168v25c0 6.9023-5.5977 12.5-12.5 12.5h-50c-6.9023 0-12.5-5.5977-12.5-12.5v-50c0-6.9023 5.5977-12.5 12.5-12.5h25c2.3008 0 4.168 1.8672 4.168 4.168s-1.8672 4.1641-4.168 4.1641z"
                ></path>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="content_device_action">
      <div class="no_hover !justify-start">
        <div>
          <p>
            {{ $e("Altitude de retour RTH") }} :
            {{ config.drone.status.rth_altitude }}m
          </p>

          <div class="flex pt-2 pb-1 text-[10px]">
            {{ $e("Modifier") }} :
            <input
              type="number"
              @change="verifRTHLimit()"
              class="ml-2 px-2 py-0 w-[100px] h-[17px] text-[11px]"
              v-model="valueRTHEdit"
              :placeholder="config.drone.status.rth_altitude"
            /> m

            <svg
              v-if="valueRTHEdit !== false"
              @click="saveRTHEdit()"
              class="w-[20px] ml-4 fill-current cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 110.0 110.0"
            >
              <g fill-rule="evenodd">
                <path
                  d="m66.52 15.805c4.8789-4.8828 12.797-4.8828 17.676 0 4.8828 4.8789 4.8828 12.797 0 17.676l-29.676 29.676c-1.7422 1.7461-3.9648 2.9336-6.3867 3.418l-12.258 2.4531c-1.3633 0.27344-2.7773-0.15625-3.7617-1.1406s-1.4141-2.3984-1.1406-3.7617l2.4531-12.258c0.48438-2.4219 1.6719-4.6445 3.418-6.3867zm11.785 5.8906c-1.6289-1.625-4.2656-1.625-5.8945 0l-1.5781 1.5781 5.8945 5.8945 1.5781-1.5781c1.625-1.6289 1.625-4.2656 0-5.8945zm-7.4727 13.363-5.8906-5.8906-22.207 22.203c-0.58203 0.58203-0.97656 1.3242-1.1367 2.1289l-1.2266 6.1289 6.1289-1.2266c0.80469-0.16016 1.5469-0.55469 2.1289-1.1367zm-45.832-14.227c-2.3008 0-4.168 1.8672-4.168 4.168v50c0 2.3008 1.8672 4.168 4.168 4.168h50c2.3008 0 4.168-1.8672 4.168-4.168v-25c0-2.3008 1.8633-4.168 4.1641-4.168s4.168 1.8672 4.168 4.168v25c0 6.9023-5.5977 12.5-12.5 12.5h-50c-6.9023 0-12.5-5.5977-12.5-12.5v-50c0-6.9023 5.5977-12.5 12.5-12.5h25c2.3008 0 4.168 1.8672 4.168 4.168s-1.8672 4.1641-4.168 4.1641z"
                ></path>
              </g>
            </svg>
          </div>
        </div>
      </div>

      <div class="no_hover !justify-start">
        <div>
          <p>
            {{ $e("Hauteur limit") }} : {{ config.drone.status.height_limit }}m
          </p>

          <div class="flex pt-2 pb-1 text-[10px]">
            {{ $e("Modifier") }} :
            <input
              type="number"
              @change="verifHeightLimit()"
              class="ml-2 px-2 py-0 w-[100px] h-[17px] text-[11px]"
              v-model="valueHeightEdit"
              :placeholder="config.drone.status.height_limit"
            /> m

            <svg
              v-if="valueHeightEdit !== false"
              @click="saveHeightLimitEdit()"
              class="w-[20px] ml-4 fill-current cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              viewBox="0 0 110.0 110.0"
            >
              <g fill-rule="evenodd">
                <path
                  d="m66.52 15.805c4.8789-4.8828 12.797-4.8828 17.676 0 4.8828 4.8789 4.8828 12.797 0 17.676l-29.676 29.676c-1.7422 1.7461-3.9648 2.9336-6.3867 3.418l-12.258 2.4531c-1.3633 0.27344-2.7773-0.15625-3.7617-1.1406s-1.4141-2.3984-1.1406-3.7617l2.4531-12.258c0.48438-2.4219 1.6719-4.6445 3.418-6.3867zm11.785 5.8906c-1.6289-1.625-4.2656-1.625-5.8945 0l-1.5781 1.5781 5.8945 5.8945 1.5781-1.5781c1.625-1.6289 1.625-4.2656 0-5.8945zm-7.4727 13.363-5.8906-5.8906-22.207 22.203c-0.58203 0.58203-0.97656 1.3242-1.1367 2.1289l-1.2266 6.1289 6.1289-1.2266c0.80469-0.16016 1.5469-0.55469 2.1289-1.1367zm-45.832-14.227c-2.3008 0-4.168 1.8672-4.168 4.168v50c0 2.3008 1.8672 4.168 4.168 4.168h50c2.3008 0 4.168-1.8672 4.168-4.168v-25c0-2.3008 1.8633-4.168 4.1641-4.168s4.168 1.8672 4.168 4.168v25c0 6.9023-5.5977 12.5-12.5 12.5h-50c-6.9023 0-12.5-5.5977-12.5-12.5v-50c0-6.9023 5.5977-12.5 12.5-12.5h25c2.3008 0 4.168 1.8672 4.168 4.168s-1.8672 4.1641-4.168 4.1641z"
                ></path>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import API from "@/utils/API";
import { toast } from "vue3-toastify";

export default {
  name: "DroneDebug",
  props: {
    config: Object,
    smallSvg: Boolean,
  },
  setup() {
    return {
      valueDistanceEdit: ref(false),
      valueRTHEdit: ref(false),
      valueHeightEdit: ref(false),
    };
  },

  mounted() {},

  methods: {
    async drone_distance_limit_status_state() {
      let state = this.DroneDistanceLimitStatusState;

      let r = await API.put(`property`, {
        DockId: this.config.dock.id,
        PropNameValue:
          `"distance_limit_status": {` +
          `"distance_limit": ${this.config.drone.status.distance_limit_status.distance_limit},` +
          `"is_near_distance_limit": ${this.config.drone.status.distance_limit_status.is_near_distance_limit},` +
          `"state": ${state ? 0 : 1}}`,
      });

      r.name =
        (state ? this.$e("Activation") : this.$e("Désactivation")) +
        this.$e(`de la distance maximale de vol`);

      this.$root.msg_replie[r.command] = {
        id: r.command,
        name: r.name,
      };
    },

    async saveDistanceEdit() {
      if (this.valueDistanceEdit == false) {
        return;
      }

      let data = await API.put(`property`, {
        DockId: this.config.dock.id,
        PropNameValue:
          `"distance_limit_status": {` +
          `"distance_limit": ${this.valueDistanceEdit},` +
          `"is_near_distance_limit": ${this.config.drone.status.distance_limit_status.is_near_distance_limit},` +
          `"state": ${this.config.drone.status.distance_limit_status.state}}`,
      });

      data.name = this.$e(`Changement de la distance maximale de vol en cours`);

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };

      this.valueDistanceEdit = false;
    },

    async saveRTHEdit() {
      if (this.valueRTHEdit == false) {
        return;
      }

      let data = await API.put(`property`, {
        DockId: this.config.dock.id,
        PropNameValue: `"rth_altitude": ${this.valueRTHEdit}`,
      });

      data.name = this.$e(`Changement de l'altitude de retour en cours`);

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };

      this.valueRTHEdit = false;
    },

    async saveHeightLimitEdit() {
      if (this.valueHeightEdit == false) {
        return;
      }

      let data = await API.put(`property`, {
        DockId: this.config.dock.id,
        PropNameValue: `"height_limit": ${this.valueHeightEdit}`,
      });

      data.name = this.$e(`Changement de la hauteur limite en cours`);

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: data.name,
      };

      this.valueHeightEdit = false;
    },

    verifDroneDistanceLimit() {
      if (this.valueDistanceEdit == false) {
        return;
      }

      if (
        this.valueDistanceEdit === "" ||
        this.valueDistanceEdit < 15 ||
        isNaN(parseInt(this.valueDistanceEdit))
      ) {
        this.valueDistanceEdit = 15;
        toast.error(
          this.$e("La distance doit être supérieur à 15m"),
          this.$root.toastConfig
        );
      } else if (this.valueDistanceEdit > 8000) {
        this.valueDistanceEdit = 8000;
        toast.error(
          this.$e("La distance doit être inférieur à 8000m"),
          this.$root.toastConfig
        );
      }
    },

    verifRTHLimit() {
      if (this.valueRTHEdit == false) {
        return;
      }

      if (
        this.valueRTHEdit === "" ||
        this.valueRTHEdit < 20 ||
        isNaN(parseInt(this.valueRTHEdit))
      ) {
        this.valueRTHEdit = 20;
        toast.error(
          this.$e("La distance doit être supérieur à 20m"),
          this.$root.toastConfig
        );
      } else if (this.valueRTHEdit > 500) {
        this.valueRTHEdit = 500;
        toast.error(
          this.$e("La distance doit être inférieur à 500m"),
          this.$root.toastConfig
        );
      }
    },

    verifHeightLimit() {
      if (this.valueHeightEdit == false) {
        return;
      }

      if (
        this.valueHeightEdit === "" ||
        this.valueHeightEdit < 20 ||
        isNaN(parseInt(this.valueHeightEdit))
      ) {
        this.valueHeightEdit = 20;
        toast.error(
          this.$e("La distance doit être supérieur à 20m"),
          this.$root.toastConfig
        );
      } else if (this.valueHeightEdit > 1500) {
        this.valueHeightEdit = 1500;
        toast.error(
          this.$e("La distance doit être inférieur à 1500m"),
          this.$root.toastConfig
        );
      }
    },
  },

  computed: {
    DroneDistanceLimitStatusState() {
      return this.config?.drone?.status?.distance_limit_status?.state !=
        undefined
        ? this.config?.drone?.status?.distance_limit_status?.state == 1
        : false;
    },
  },
};
</script>
